import React from "react";
import moment, {Moment} from "moment";
import {BroomButton} from "../../../../../elements/broomButton/BroomButton";
import {CustomDateRangePicker} from "../../../../../elements/datePicker/CustomDateRangePicker";
import {MultiSelectTableFilterDropdown} from "../../../../../elements/multiSelectTableFilter/MultiSelectTableFilterDropdown";
import {ConversationChannel, TranscriptAnalyticsRequest} from "../../../../../../api/generated";
import {analyticsChannelOptions} from "../../../analyticsSlice";
import {SelectOption} from "../../../../../elements/select/SelectDropdown";
import styles from "./AnalyticsFilters.module.css";

interface AnalyticsFiltersProps {
    botOptions: SelectOption<string>[];
    request: TranscriptAnalyticsRequest;
    onAssistantChange: (publicBotIds: string[]) => void;
    onChannelChange: (channels: ConversationChannel[]) => void;
    onDateRangeChange: (start: Moment, end: Moment) => void;
    onReset: () => void;
}

export const AnalyticsFilters: React.FC<AnalyticsFiltersProps> = ({
    botOptions,
    request,
    onAssistantChange,
    onChannelChange,
    onDateRangeChange,
    onReset,
}) => {
    return <div className={styles.filterWrapper}>
        {botOptions.length > 1 && (
            <div className={styles.filterControl}>
                <MultiSelectTableFilterDropdown<string, {}>
                    value={request.publicBotIdList || []}
                    placeholder={"Filter by Assistant"}
                    width={220}
                    handleChange={onAssistantChange}
                    options={botOptions}
                />
            </div>
        )}
        <div className={styles.filterControl}>
            <MultiSelectTableFilterDropdown<ConversationChannel, {}>
                value={request.conversationChannelList || []}
                placeholder={"Filter by Channel"}
                width={240}
                handleChange={onChannelChange}
                options={analyticsChannelOptions}
            />
        </div>
        <div className={styles.filterControl}>
            <CustomDateRangePicker
                startDate={moment(request.startDate)}
                endDate={moment(request.endDate)}
                onChange={onDateRangeChange}
            />
        </div>
        <div className={styles.filterControl}>
            <BroomButton disabled={false} handleClick={onReset}/>
        </div>
    </div>;
};
